import React, { useEffect, useState } from 'react';
import { supabase } from '../supabase';
import { resolveContactsForProperty } from '../utils/contactResolve';

const SCOPE_LABEL = { ALL: 'All parcels', RE: 'RE only', BPP: 'BPP only' };

// Read-only resolved contact list for a property, grouped BY PERSON (one row per contact, assignments underneath).
// Bottom row: pick an EXISTING contact from the client pool (→ modal populated for that person, this property prefilled
// as a new row) OR create a new one. onOpenModal({ contact, prefillPropertyId }) drives the single shared ContactModal.
export default function PropertyContactsCard({ propertyId, clientId, refreshKey, isDark, onOpenModal }) {
  const [people, setPeople] = useState([]);   // assigned to THIS property (grouped by person)
  const [pool, setPool] = useState([]);        // all of the client's contacts (for the "add existing" picker)
  const [labels, setLabels] = useState({});
  const [loading, setLoading] = useState(true);
  useEffect(() => { (async () => {
    setLoading(true);
    setPeople(await resolveContactsForProperty(propertyId));
    setPool((await supabase.from('client_contacts').select('id,first_name,last_name,title,email,phone').eq('client_id', clientId).order('last_name')).data || []);
    const lid = (await supabase.from('lookup_lists').select('id').eq('name', 'Contact Roles').maybeSingle()).data?.id;
    if (lid) setLabels(Object.fromEntries(((await supabase.from('lookup_options').select('label,code').eq('list_id', lid)).data || []).map(x => [x.code, x.label])));
    setLoading(false);
  })(); }, [propertyId, clientId, refreshKey]);

  const slate = 'var(--slate)', ink = isDark ? '#e8eaf2' : 'var(--ink)', line = 'var(--line)';
  return (
    <div>
      {loading ? <div style={{ fontSize: '12px', color: slate }}>Loading…</div> :
        people.length === 0 ? <div style={{ fontSize: '12px', color: slate, marginBottom: '8px' }}>No contacts assigned to this property yet.</div> :
        people.map(({ contact, assignments }) => (
          <div key={contact.id} onClick={() => onOpenModal({ contact, prefillPropertyId: null })} style={{ padding: '8px 0', borderBottom: `1px solid ${line}`, cursor: 'pointer' }}>
            <div style={{ fontSize: '13px', fontWeight: 600, color: ink }}>{contact.first_name} {contact.last_name}{contact.title ? <span style={{ fontWeight: 400, color: slate }}> · {contact.title}</span> : null}</div>
            <div style={{ fontSize: '11px', color: slate, marginTop: '2px' }}>{assignments.map((a, i) => <span key={i} style={{ marginRight: '8px' }}>{labels[a.role] || a.role}{a.scope !== 'ALL' ? ` (${SCOPE_LABEL[a.scope]})` : ''}</span>)}</div>
          </div>
        ))}
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginTop: '12px', flexWrap: 'wrap' }}>
        {/* Common case: attach an EXISTING person from the pool. Picking opens the modal for that contact + this property prefilled. */}
        <select value="" onChange={e => { const ct = pool.find(p => p.id === e.target.value); if (ct) onOpenModal({ contact: ct, prefillPropertyId: propertyId }); }}
          style={{ flex: '1 1 220px', minWidth: '160px', padding: '6px 9px', fontSize: '12px', border: `1px solid ${line}`, borderRadius: '7px', background: isDark ? 'rgba(0,0,0,0.2)' : '#fff', color: ink }}>
          <option value="">+ Add existing contact…</option>
          {pool.map(p => <option key={p.id} value={p.id}>{p.first_name} {p.last_name}{p.email ? ` · ${p.email}` : ''}</option>)}
        </select>
        <button onClick={() => onOpenModal({ contact: null, prefillPropertyId: propertyId })}
          style={{ padding: '6px 12px', fontSize: '12px', fontWeight: 700, background: 'transparent', border: `1px solid ${line}`, borderRadius: '7px', color: slate, cursor: 'pointer', whiteSpace: 'nowrap' }}>+ New contact</button>
      </div>
    </div>
  );
}
